import { render, staticRenderFns } from "./CameraPageIntroductionPcBookImages.vue?vue&type=template&id=3aaab5fc&scoped=true&"
import script from "./CameraPageIntroductionPcBookImages.vue?vue&type=script&lang=ts&"
export * from "./CameraPageIntroductionPcBookImages.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageIntroductionPcBookImages.vue?vue&type=style&index=0&id=3aaab5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaab5fc",
  null
  
)

export default component.exports